const dev = {
    baseURL: 'https://aoxc6i9l8i.execute-api.ap-southeast-2.amazonaws.com/Prod/api/',
    landingPageUrl: "https://app.mealpalai.com",
    stripe: {
        free: "price_1MxfCeKQPQWOoa2fejfw4bYF",
        entry: "price_1MxfD2KQPQWOoa2fMlMF79vF",
        pro: "price_1MxfDzKQPQWOoa2fzMgMxcfW"
    },
    stripeInstalled: true,
    freePlanSubscriptionRequired: true,
    stripeFreeWords: 20000,
    stripeEntryWords: 99999,
    stripePremiumWords: 99999,
    stripeProWords: "Unlimited",
};

const prod = {
    baseURL: 'https://aoxc6i9l8i.execute-api.ap-southeast-2.amazonaws.com/Prod/api/',
    landingPageUrl: "https://app.mealpalai.com",
    stripe: {
        free: "price_1MxfCeKQPQWOoa2fejfw4bYF",
        entry: "price_1MxfD2KQPQWOoa2fMlMF79vF",
        pro: "price_1MxfDzKQPQWOoa2fzMgMxcfW"
    },
    stripeInstalled: true,
    freePlanSubscriptionRequired: true,
    stripeFreeWords: 20000,
    stripeEntryWords: 99999,
    stripePremiumWords: 99999,
    stripeProWords: "Unlimited",
};

const config = process.env.NODE_ENV === 'development'
    ? dev
    : prod;

export default config;